<template>
  <div class="text-left" id="router" style="padding-top:3%" :style="viewStyle">
    <div id="box" class="pa-5">
      <v-row justify="center">
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-phone</v-icon>
            <h4 class="pt-1">電話：03- 4264248</h4>
          </v-row>
        </v-col>
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-shredder</v-icon>
            <h4 class="pt-1">傳真：03- 4257209</h4>
          </v-row>
        </v-col>
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-email-outline</v-icon>
            <h4 class="pt-1">service@cerps.org.tw</h4>
          </v-row>
        </v-col>
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-map-marker</v-icon>
            <h4 class="pt-1">(320317) 桃園市中壢區中大路300號</h4>
          </v-row>
        </v-col>
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-facebook</v-icon>
            <h4 class="pt-1">中華企業資源規劃學會</h4>
          </v-row>
        </v-col>
        <v-col class="pt-4 pl-9 col-12 col-sm-6">
          <v-row>
            <v-icon class="pr-3" size="32">mdi-instagram</v-icon>
            <h4 class="pt-1">@erp_ncu</h4>
          </v-row>
        </v-col> 
      </v-row>
    </div>
    <v-row class="ma-0" justify="center">
      <h4 class="start">*如有任何疑問請來信詢問。</h4>
    </v-row>
    <!-- <div id="box" class="pa-5 mt-3">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1">帳號資料及聯絡內容</h4>
      </v-row>
      <v-row class="mx-2">
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>中文姓名</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.name"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>學校/單位名稱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.company"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>系所/部門</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.department"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>電子信箱</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.email"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14">聯絡電話</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.tel"></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col class="px-0 col-2 col-md-4">
              <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="memberInfo.ctel"
              @keyup="[memberInfo.ctel= memberInfo.ctel.replace(/\D/g,'')]" :maxlength="10"></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pa-0 col-12 col-md-6">
          <v-row class="ma-0">
            <v-col class="pa-0 col-2 col-md-2">
              <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡內容</div>
            </v-col>
            <v-col class="col-10 col-md-8">
              <textarea class="text_field pa-4" rows="11" outlined required dense style="width:100%; background:white; border: 1px solid #999999" v-model="note"></textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <h5 class="text-center start">若您有帳號資料須修改，請至"帳號資料修改"完整填寫您的基本資料。</h5>
    </div>
    <div class="mt-8"> 
      <v-row class="ma-0 pa-0" justify="center">
        <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" 
        @click="newDataset()">
          <span style="color:#FFFFFF">送出資料</span>
        </v-btn>
      </v-row>
    </div> -->
    <ShowMsg ref="ShowMsg" />
  </div>
</template>

<script>
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'Contact',
  components: {ShowMsg},
  mounted(){
    this.getMemberInfo()
  },
  data:() => ({
    datasets: [],
    destPage:'',
    viewStyle:{},
    memberInfo: {},
    note:'',
    requiredField:['name','company','department','email','ctel'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    getMemberInfo(){
      var self = this
      var request = {
        method: 'GET',
        url: ((sessionStorage.getItem('cerpsMemberType').includes('erpMember')) ? '/erpMember/' : '/erpTeacher/') + sessionStorage.getItem('cerpsMemberId'),
        params: {},
      }
      this.$http(request)
        .then(function(response) {
          self.memberInfo = response.data.data
        }).catch(()=>{
          console.log('系統錯誤','請聯繫系統管理人員，編號為Cot-7956')
      })
    },
    newDataset() {
      if(!this.$Global.checkForm(this.memberInfo,this.requiredField)){
        this.$refs.ShowMsg.open(16) // 基本資料不完全
        return
      }
      if(!this.note){
        this.$refs.ShowMsg.open(1)
        return
      }  
      var allData = this.$Global.copy(this.memberInfo)
      allData = this.$Global.jsonConcat(allData,{'id': ''})
      allData = this.$Global.jsonConcat(allData,{'wtime': ''})
      allData = this.$Global.jsonConcat(allData,{'note1':this.note})
      console.log(allData)
      var self = this
      var request = {
        method: 'POST',
        url: '/contactUs',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(17) // 送出成功
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Cot-7957')
      }).finally(()=>{
        self.note = ''
      })
    },
  }
}
</script>